import { List, P, Strong } from '@ahmdigital/ui';

import { ambulanceDisclaimerTasQld } from './shared';

export default {
  intro: {
    accidentOverrideDescription: (
      <>
        <P>
          Silver plus hospital with the most shine, but none of the pregnancy things. These additional hospital services
          are included:
        </P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Joint replacements</Strong>
          </li>
          <li>
            <Strong>Cataracts</Strong>
          </li>
          <li>
            <Strong>Sleep studies</Strong>
          </li>
          <li>
            <Strong>Palliative care</Strong>
          </li>
          <li>
            <Strong>Rehab</Strong>
          </li>
          <li>
            <Strong>No excess for dependants</Strong>
          </li>
          <li>
            <Strong>Unlimited medically necessary ambulance^</Strong>
          </li>
        </List>
      </>
    ),
    description: (
      <>
        <P>
          Silver plus hospital with the most shine, but none of the pregnancy things. These additional hospital services
          are included:
        </P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Joint replacements</Strong>
          </li>
          <li>
            <Strong>Cataracts</Strong>
          </li>
          <li>
            <Strong>Sleep studies</Strong>
          </li>
        </List>
        <P>
          Palliative care and rehab are also included. You also get{' '}
          <Strong>unlimited medically necessary ambulance^</Strong>, accident override and no excess for dependants.
        </P>
      </>
    ),
    disclaimer: ambulanceDisclaimerTasQld,
  },
};
